import React from "react";
import "./ComingSoonCard.css";

interface ComingSoonCardProps {
  /** Optional pill in the top-right corner (e.g. "Coming soon"). */
  badge?: string;
  icon: React.ReactNode;
  title: string;
  body: string;
  /** When set, renders a footer row "<label> — " as a placeholder metric. */
  footerLabel?: string;
}

/**
 * Reusable dashed "coming soon" card for teasing an upcoming feature (e.g. the
 * dashboard's Referral card). Presentational only — callers pass the icon + copy.
 */
export const ComingSoonCard: React.FC<ComingSoonCardProps> = ({
  badge,
  icon,
  title,
  body,
  footerLabel,
}) => (
  <div className="coming-soon-card">
    {badge && <span className="coming-soon-card-badge">{badge}</span>}
    <div className="coming-soon-card-body">
      <span className="coming-soon-card-icon">{icon}</span>
      <div className="coming-soon-card-title">{title}</div>
      <p className="coming-soon-card-text">{body}</p>
    </div>
    {footerLabel && (
      <div className="coming-soon-card-footer">
        <span>{footerLabel}</span>
        <span className="coming-soon-card-dash">—</span>
      </div>
    )}
  </div>
);
